export const questions = {
  evicted:
    'Have you (or any person you have named on this application) ever been evicted from a tenancy or left owing money?',
  conviction:
    'Have you or any member of your household ever been convicted of (or pled guilty or no contest to) any criminal offense(s) other than a minor infraction(s) that were disposed of by means other than acquittal or a finding of "not guilty"?',
  civil_action:
    'Have you (or any person you have named on this application) ever filed for or been involved in a bankruptcy, been foreclosed on, or been a defendant in a civil suit?',
};
